import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const Unauthorized = ({ title }) => {
  document.title = title;
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="Access denied"
      subTitle="Your role does not currently have permission to access this page."
      extra={
        <Button type="primary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      }
    />
  );
};

export default Unauthorized;
